import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import PageHeaderV2 from "../pageheaderV2/PageHeaderV2";
import moment from "moment/moment";
import "moment/locale/th";
import Input from "../material/input/Input";
import icon__search from "../../asset/icon/search.svg";
import styles from "./TableManage.module.css";
import { TrashIcon } from "@heroicons/react/24/outline";
import MenuAdmin from "./navAdmin/Menu";
import Pagination from "./../pagination/Pagination";
import Button from "../material/button/Button";
import { Option, Select } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import icon__plus from "../../asset/icon/plus-small.svg";
import { HashLoader } from "react-spinners";
import * as AdminApi from "../../service/adminApi";
import { RedirectCode400 } from "../RedirectCode400";
import design from "./UserManament.module.css";

import { CurrentUserContext } from "../../App";

import DataTable from "react-data-table-component";
import DialogTailwindConfirm from "../DialogTailwindConfirm";

import Breadcrumb from "../breadcrumb/breadcrumb";
import TableV1 from "../tableV1/tableV1";

const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function UserManament() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const userAuthCurrent = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [inputvalue, setInputValue] = useState("");
  const [selectValueOption, setSelectValueOption] = useState("ADMIN");
  const [saveData, setSaveData] = useState([]);
  const [userDataList, setUserDataList] = useState([]);

  const [selectedEnable, setSelectedEnable] = useState(true);

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpenApproved, setIsDialogOpenApproved] = useState(false);
  const [selectedDataApproved, setSelectedDataApproved] = useState(null);

  const optionStatusList = [
    {
      value: true,
      key: "Active",
    },
    {
      value: false,
      key: "InActive",
    },
  ];

  const optionList = [
    {
      role: "ADMIN",
      value: "แอดมิน",
    },
    {
      role: "MEDICAL_PERSONNEL",
      value: "แพทย์/เภสัชกร",
    },
    {
      role: "LABORATORY_ADMIN",
      value: "Admin ห้องปฏิบัติการ",
    },
    {
      role: "LABORATORY_PERSONNEL",
      value: "Staff ห้องปฏิบัติการ",
    },
    {
      role: "PATIENT",
      value: "ประชาชน",
    },
    {
      role: "EXECUTIVE",
      value: "ผู้บริหาร",
    },
    {
      role: "HOSPITAL",
      value: "โรงพยาบาล",
    },
    {
      role: "HOSPITAL_PERSONNEL",
      value: "เจ้าหน้าที่โรงพยาบาล",
    },
  ];

  useEffect(() => {
    setDate(moment().add(543, "years").format("DD MMMM YYYY"));
  }, []);

  useEffect(() => {
    getUserDataList();
  }, [selectValueOption, page, selectedEnable]);

  useEffect(() => {
    setPage(1);
  }, [selectValueOption, selectedEnable]);

  //เอาข้อมูลตาราง
  const getUserDataList = async () => {
    let res = "";
    setLoading(true);
    res = await AdminApi.getUserDataList(
      selectValueOption,
      page,
      10,
      selectedEnable,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        setUserDataList(res["data"]["user_data_list"]);
        setSaveData(res["data"]["user_data_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const ManageUserApprove = async (uid, approve) => {
    let res = "";
    res = await AdminApi.ManageUserApprove(uid, approve);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
        getUserDataList();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  /*
  const ManageUserEnable = async (uid, enable) => {
    let res = ''
    res = await AdminApi.ManageUserEnable(uid, enable)
    if (res) {
      if (res['data']['code'] === 200) {
        console.log(res['data']['message_th'] || res['data']['message'])
        getUserDataList()
      } else if (res['data']['code'] === 403) {
        navigate(RedirectCode400())
      } else {
        console.log(res['data']['message_th'] || res['data']['message'])
      }
    } else {
      setIsMessage({type: 'error', data: 'เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่'})
    } 
  }*/

  const handleChangeSearch = (value) => {
    setInputValue(value);
  };

  const handleClickSearch = () => {
    if (inputvalue !== "") {
      const filterData = userDataList.filter((item) => {
        return item["pid"]?.toLowerCase().includes(inputvalue?.toLowerCase());
      });
      setUserDataList(filterData);
    } else {
      setUserDataList(saveData);
    }
  };

  const handleChange = (event) => {
    //ใช้material-tailwind/react ไม่ต้อง target.value
    setSelectValueOption(event);
    setInputValue("");
    // console.log(event);
  };

  const handleChangeStatus = (event) => {
    setSelectedEnable(event);
  };

  const clickFile = (url) => {
    window.open(url);
  };

  //เปิด Dialog
  const handleConfirm = async (confirmed, data) => {
    setIsDialogOpen(false);
    if (confirmed && data) {
      if (data?.uid && typeof data.isAuthDisabled !== "undefined") {
        // console.log(data);
        let res = "";
        res = await AdminApi.ManageUserEnable(data.uid, data.isAuthDisabled);
        if (res) {
          if (res["data"]["code"] === 200) {
            // console.log(res["data"]["message_th"] || res["data"]["message"]);
            getUserDataList();
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            // console.log(res["data"]["message_th"] || res["data"]["message"]);
          }
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    }
  };

  // ฟังก์ชันเปิด dialog พร้อมบันทึกข้อมูล row ที่ต้องการ
  const openDialog = (rowData) => {
    setSelectedData(rowData);
    setIsDialogOpen(true);
  };

  //เปิด Dialog Approved
  const handleConfirmApproved = async (confirmed, data) => {
    setIsDialogOpenApproved(false);
    // console.log(data)
    if (confirmed && data) {
      ManageUserApprove(data.uid, data.isAuthDisabled);
    }
  };
  const openDialogApproved = (rowData) => {
    setSelectedDataApproved(rowData);
    setIsDialogOpenApproved(true);
  };

  const columnsLabAdmin = [
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["fname"]}</div>,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["lname"]}</div>,
    },
    {
      name: "เบอร์โทร",
      selector: (i) => <div>{i["phone_number"]}</div>,
    },
    {
      name: "เลขใบประกอบวิชาชีพ",
      selector: (i) => (
        <div>{i["license_number"] ? i["license_number"] : "-"}</div>
      ),
      minWidth: "200px",
    },
    {
      name: "ไฟล์คำร้อง",
      selector: (i) => (
        <div>
          {i["attachment_file"] ? (
            <button
              className="flex justify-center items-center"
              style={{
                width: "120px",
                height: "30px",
                backgroundColor: "#ffffff",
                borderRadius: "20px",
                color: "#7BC798",
                fontSize: "14px",
                border: "1px solid #7BC798",
              }}
              onClick={() => {
                clickFile(i["attachment_file"]["url"]);
              }}
            >
              ดูไฟล์
            </button>
          ) : (
            <div
              className="flex justify-center items-center"
              style={{
                width: "120px",
                height: "30px",
                backgroundColor: "#ffffff",
                borderRadius: "20px",
                color: "#BEBEBE",
                fontSize: "14px",
                border: "1px solid #BEBEBE",
              }}
            >
              ไม่มีไฟล์คำร้อง
            </div>
          )}
        </div>
      ),
      minWidth: "160px",
    },
    {
      name: "ชื่อห้องแลป",
      selector: (i) => <div>{i["laboratory"]?.["laboratory_name"]}</div>,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "อนุมัติผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["auth"]["approve"] === true ? (
            <div className="flex justify-center items-center">
              <div style={{ color: "#64BD86", fontSize: "14px" }}>
                อนุมัติแล้ว
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialogApproved({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง อนุมัติ ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["approve"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                ยังไม่อนุมัติ
              </button>
            </div>
          )}
        </div>
      ),
      minWidth: "140px",
    },
    {
      name: "สถานะผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["auth"]["enable"] === true ? (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialog({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง Inactive ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["enable"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#64BD86] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-hard-green "
              >
                Active
              </button>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialog({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง Active ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["enable"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                Inactive
              </button>
            </div>
          )}
        </div>
      ),
      minWidth: "140px",
    },
  ];

  // const columnsLabPersonal = [
  //   {
  //     name: 'ชื่อ',
  //     selector: i => <div>{i['fname']}</div>
  //   },
  //   {
  //     name: 'นามสกุล',
  //     selector: i => <div>{i['lname']}</div>
  //   },
  //   {
  //     name: 'เบอร์โทร',
  //     selector: i => <div>{i['phone_number']}</div>
  //   },
  //   {
  //     name: 'เลขใบประกอบวิชาชีพ',
  //     selector: i => <div>{i['license_number']}</div>,
  //     minWidth: '200px'
  //   },
  //   {
  //     name: 'ไฟล์คำร้อง',
  //     selector: i =>
  //       <div>
  //         {i['attachment_file'] ?
  //           <button className='flex justify-center items-center' style={{ width: '120px', height: '30px', backgroundColor: '#ffffff', borderRadius: '20px', color: '#7BC798', fontSize: '14px', border: '1px solid #7BC798' }} onClick={() => { clickFile(i['attachment_file']['url']) }} >ดูไฟล์</button>
  //           :
  //           <div className='flex justify-center items-center' style={{ width: '120px', height: '30px', backgroundColor: '#ffffff', borderRadius: '20px', color: '#BEBEBE', fontSize: '14px', border: '1px solid #BEBEBE' }}>ไม่มีไฟล์คำร้อง</div>
  //         }
  //       </div>
  //   },
  //   {
  //     name: 'ชื่อห้องแลป',
  //     selector: i => <div>{i['laboratory']?.['laboratory_name']}</div>,
  //     minWidth: '250px',
  //     wrap: true
  //   },
  //   {
  //     name: 'อนุมัติผู้ใช้งาน',
  //     selector: i =>
  //       <div>
  //         {i['auth']['approve'] === true ?
  //           <div className='flex justify-center items-center'>
  //             <div style={{ color: '#64BD86', fontSize: '14px' }}>อนุมัติแล้ว</div>
  //           </div> :
  //           <div className='flex justify-center items-center'>
  //             <button onClick={() => { ManageUserApprove(i['uid'], !(i['auth']['approve'])) }} className='button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray '>
  //               ยังไม่อนุมัติ
  //             </button>
  //           </div>
  //         }
  //       </div>
  //   },
  //   {
  //     name: 'สถานะผู้ใช้งาน',
  //     selector: i =>
  //       <div>
  //         {i['auth']['enable'] === true ?
  //           <div className='flex justify-center items-center'>
  //             <button onClick={() => { ManageUserEnable(i['uid'], !(i['auth']['enable'])) }} className='button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#64BD86] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-hard-green '>
  //               Active
  //             </button>
  //           </div>
  //           :
  //           <div className='flex justify-center items-center'>
  //             <button onClick={() => { ManageUserEnable(i['uid'], !(i['auth']['enable'])) }} className='button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray '>
  //               Inactive
  //             </button>
  //           </div>
  //         }
  //       </div>
  //   },

  // ]

  const columnsHospital = [
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["fname"]}</div>,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["lname"]}</div>,
    },
    {
      name: "เบอร์โทร",
      selector: (i) => <div>{i["phone_number"]}</div>,
    },
    {
      name: "ประเภท",
      selector: (i) => <div>{i["auth"]["role"][0]}</div>,
    },
    {
      name: "โรงพยาบาล",
      selector: (i) => <div>{i["hospital"]?.["hospital_name"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "อนุมัติผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["auth"]["approve"] === true ? (
            <div className="flex justify-center items-center">
              <div style={{ color: "#64BD86", fontSize: "14px" }}>
                อนุมัติแล้ว
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialogApproved({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง อนุมัติ ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["approve"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                ยังไม่อนุมัติ
              </button>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "สถานะผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["auth"]["enable"] === true ? (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialog({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง Inactive ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["enable"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#64BD86] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-hard-green "
              >
                Active
              </button>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialog({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง Active ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["enable"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                Inactive
              </button>
            </div>
          )}
        </div>
      ),
    },
  ];

  const columnsMedical = [
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["fname"]}</div>,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["lname"]}</div>,
    },
    {
      name: "เบอร์โทร",
      selector: (i) => <div>{i["phone_number"]}</div>,
    },
    {
      name: "เลขใบประกอบวิชาชีพ",
      selector: (i) => (
        <div>{i["license_number"] ? i["license_number"] : "-"}</div>
      ),
      minWidth: "200px",
    },
    {
      name: "โรงพยาบาล",
      selector: (i) => <div>{i["hospital"]?.["hospital_name"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "อนุมัติผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["auth"]["approve"] === true ? (
            <div className="flex justify-center items-center">
              <div style={{ color: "#64BD86", fontSize: "14px" }}>
                อนุมัติแล้ว
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialogApproved({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง อนุมัติ ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["approve"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                ยังไม่อนุมัติ
              </button>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "สถานะผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["auth"]["enable"] === true ? (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialog({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง Inactive ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["enable"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#64BD86] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-hard-green "
              >
                Active
              </button>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialog({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง Active ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["enable"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                Inactive
              </button>
            </div>
          )}
        </div>
      ),
    },
  ];

  const columnsOther = [
    {
      name: "No.",
      selector: (i) => <div>{i["fname"]}</div>,
      wrap: true,
    },
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["fname"]}</div>,
      wrap: true,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["lname"]}</div>,
      wrap: true,
    },
    {
      name: "เบอร์โทร",
      selector: (i) => <div>{i["phone_number"]}</div>,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "ประเภท",
      selector: (i) => <div>{i["auth"]["role"][0]}</div>,
      wrap: true,
    },
    {
      name: "อนุมัติผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["auth"]["approve"] === true ? (
            <div className="flex justify-center items-center">
              <div style={{ color: "#64BD86", fontSize: "14px" }}>
                อนุมัติแล้ว
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialogApproved({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง อนุมัติ ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                    uid: i["uid"],
                    isAuthDisabled: !i["auth"]["approve"],
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                ยังไม่อนุมัติ
              </button>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "สถานะผู้ใช้งาน",
      selector: (i) => (
        <div>
          {i["uid"] != "cf637680-d746-5fe6-977a-7d0bca9ae9f5" &&
          userAuthCurrent?.uid != i["uid"] ? (
            i["auth"]["enable"] === true ? (
              <div className="flex justify-center items-center">
                <button
                  onClick={() =>
                    openDialog({
                      message: `กรุณายืนยันการทำรายการ คุณกำลัง Inactive ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                      uid: i["uid"],
                      isAuthDisabled: !i["auth"]["enable"],
                    })
                  }
                  className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#64BD86] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-hard-green "
                >
                  Active
                </button>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <button
                  onClick={() =>
                    openDialog({
                      message: `กรุณายืนยันการทำรายการ คุณกำลัง Active ผู้ใช้งาน ${i["fname"]} ใช่หรือไม่ `,
                      uid: i["uid"],
                      isAuthDisabled: !i["auth"]["enable"],
                    })
                  }
                  className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
                >
                  Inactive
                </button>
              </div>
            )
          ) : (
            <div className="flex justify-center items-center">
              <div style={{ color: "#64BD86", fontSize: "14px" }}>Active</div>
            </div>
          )}
        </div>
      ),
    },
  ];

  // console.log(userDataList);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "จัดการผู้ใช้งาน", url: "/usermanagement" },
  ];

  return (
    <div className="global-page">
      <MenuAdmin menuActive="usermanagement" />
      <Breadcrumb pathItems={pathItems} />
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
      <PageHeaderV2 titlename="ผู้ใช้งานระบบ" />
      <div>
        {/* <div className='flex items-stretch md:flex-col md:gap-1 gap-3'>
          <div className='md:text-[16px] text-xl'>รายชื่อเจ้าหน้าที่ในระบบทั้งหมด</div>
          <div className='md:text-[12px] text-[#000000] self-center lg:self-start'>{`(ข้อมูลวันที่ ${date})`}</div>
        </div>
        <div className='md:text-[12px] text-[#000000] mt-2 mb-2'>{`จำนวน ${userDataList.length} คน`}</div> */}

        {/* <div className="flex w-full md:w-full gap-4 py-4 md:flex-col">
          <div className="w-[400px]">
            <Select label="ประเภทของผู้เข้าใช้งาน" color={'orange'}
              value={selectValueOption}
              onChange={handleChange}
            >
              {optionList.map((i, idx) => {
                return (
                  <Option key={idx} value={i['role']}>{i['value']}</Option>
                )
              })
              }
            </Select>
          </div>

          <div className="w-[400px]">
            <Select label="สถานะของผู้ใช้งาน" color={'orange'}
              value={selectedEnable}
              onChange={handleChangeStatus}
            >
              {optionStatusList.map((i, idx) => {
                return (
                  <Option key={idx} value={i['value']}>{i['key']}</Option>
                )
              })
              }
            </Select>
          </div>
        </div> */}

        <div className="flex flex-col w-[50%] md:w-[100%]">
          <div className={`md:text-[16px] text-xl ${design.font}`}>
            รายชื่อเจ้าหน้าที่ในระบบทั้งหมด
          </div>
          <Input
            disabledLabel={true}
            placeholder="ค้นหาด้วยเลขบัตรประชาชน"
            type="number"
            value={inputvalue}
            setValue={handleChangeSearch}
          />
        </div>

        {selectValueOption === "LABORATORY_ADMIN" ||
        selectValueOption === "LABORATORY_PERSONNEL" ? (
          <div className={styles.align}>
            <DataTable
              className="classTable"
              columns={columnsLabAdmin}
              data={userDataList}
              customStyles={customStyles}
              noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
            />
          </div>
        ) : null}

        {selectValueOption === "MEDICAL_PERSONNEL" ? (
          <div className={styles.align}>
            <DataTable
              className="classTable"
              columns={columnsMedical}
              data={userDataList}
              customStyles={customStyles}
              noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
            />
          </div>
        ) : null}

        {selectValueOption === "HOSPITAL" ||
        selectValueOption === "HOSPITAL_PERSONNEL" ? (
          <div className={styles.align}>
            <DataTable
              className="classTable"
              columns={columnsHospital}
              data={userDataList}
              customStyles={customStyles}
              noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
            />
          </div>
        ) : null}

        {selectValueOption === "ADMIN" ||
        selectValueOption === "PATIENT" ||
        selectValueOption === "EXECUTIVE" ? (
          <div className={styles.align}>
            <DataTable
              className="classTable"
              columns={columnsOther}
              data={userDataList}
              customStyles={customStyles}
              noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
            />

            {/* <TableV1 columns={columnsOther}/> */}
          </div>
        ) : null}

        {/* เปิด DialogTailwindConfirm พร้อมส่งข้อมูล row ที่เลือก */}
        {isDialogOpen && selectedData && (
          <DialogTailwindConfirm
            onConfirm={handleConfirm}
            onCancel={handleConfirm}
            data={selectedData}
          />
        )}

        {isDialogOpenApproved && selectedDataApproved && (
          <DialogTailwindConfirm
            onConfirm={handleConfirmApproved}
            onCancel={handleConfirmApproved}
            data={selectedDataApproved}
          />
        )}

        <Pagination
          page={page}
          totalpage={maxPage}
          clickForward={() => {
            if (page < maxPage) {
              setPage(page + 1);
            }
          }}
          clickBackward={() => {
            if (page > 1) {
              setPage(page - 1);
            }
          }}
        />
      </div>
    </div>
  );
}

export default UserManament;
